define( function() {
	"use strict";

	return window.document;
} );



//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/src/var/document.js
// module id = rY9R
// module chunks = 0 1